export default "assets/images/chateaux-logos/le-boscq-9ec8f9c7.png";